import React from "react";
import { observer, useLocalStore } from "mobx-react";
import { DownOutlined, UpOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button, Tag, Tooltip } from "antd";
import UserChip from "@app/components/user/chip";
import format from "@app/lib/format";
import moment from "moment";

import Group from "@app/components/setup/group";

import "./style/group.scoped.scss";

const StageGroup = observer(
    ({ title, users, complete, stage, onAdd, onEdit, onDelete, onRemove }) => {
        const state = useLocalStore(() => ({
            opened: true,

            toggle() {
                this.opened = !this.opened;
            },
        }));

        const addUser = async (event) => {
            event.preventDefault();
            event.stopPropagation();

            onAdd();
        };

        const removeUser = async (id, args = {}) => {
            onRemove(id);
        };

        const deleteStage = async () => {
            onDelete();
        };

        const count = users.length;
        const hasEscalation = stage?.escalationEnabled;
        const isLate = stage?.deadline && !complete && moment(stage.deadline).isBefore();

        return (
            <Group
                title={
                    <div className="expand-header">
                        <div className="expand-toggle" onClick={state.toggle}>
                            <div className="toggle">
                                {state.opened ? <UpOutlined /> : <DownOutlined />}
                            </div>
                        </div>
                        {title} ({count})
                        {stage?.deadline && (
                            <div className="deadline">
                                <Tooltip title="Review deadline">
                                    <Tag color={isLate ? "red" : "default"}>
                                        Deadline: {format.date(stage.deadline)}
                                    </Tag>
                                </Tooltip>
                            </div>
                        )}
                    </div>
                }
                right={complete ? <Tag color="green">complete</Tag> : null}
                onEdit={complete ? undefined : onEdit}
                onAdd={complete ? undefined : addUser}
                onDelete={complete ? undefined : deleteStage}
            >
                {state.opened && (
                    <>
                        {hasEscalation && (
                            <div className="escalations">
                                <div className="title">Review Escalations</div>

                                {stage.escalationTriggers.map((trigger) => {
                                    const isInactive = moment()
                                        .endOf("day")
                                        .isAfter(trigger.triggerDate);
                                    return (
                                        <div className="trigger">
                                            <div className="days">
                                                Notify {trigger.days} days before deadline{" "}
                                                <i>({format.date(trigger.triggerDate)})</i>
                                                {isInactive && (
                                                    <>
                                                        &nbsp; <Tag>Inactive</Tag>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {users.map((user) => {
                            return (
                                <div className="user" key={user._id}>
                                    <UserChip user={user} />
                                    <div className="buttons">
                                        {!complete && (
                                            <Button
                                                onClick={() => removeUser(user._id)}
                                                type="text"
                                                danger
                                                icon={<DeleteOutlined />}
                                            ></Button>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </>
                )}
            </Group>
        );
    },
);

export default StageGroup;
